export default __webpack_public_path__ + "static/media/488.6adbceb1.gif";